import React, { FC } from 'react';
import { ReactComponent as EthIcon } from '../../assets/svg/icons/currency-ethereum.svg';
import cls from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { selectEnteredEthAmount, selectIsEthInputOpen } from '../../ducks/app/selectors';
import { addEth, setEthInputOpen } from '../../ducks/app/actions';
import { IconComp } from '../../components/SwapKiwi/IconComponent';
export const AddEth: FC = () => {
  const dispatch = useDispatch();
  const isEthInputOpen = useSelector(selectIsEthInputOpen);
  const enteredEthAmount = useSelector(selectEnteredEthAmount) || '';

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    if (parseFloat(e.target.value) < 0) {
      e.target.value = (parseFloat(e.target.value) * -1).toString();
    }

    if (!!e.target.value) {
      dispatch(addEth(parseFloat(e.target.value)));
    } else dispatch(addEth(0));
  };

  return (
    <div
      onClick={(): void => {
        !isEthInputOpen && dispatch(setEthInputOpen(true));
      }}
      className={cls(
        'min-h-15.25 w-10 border border-cloud-900 rounded-xl flex flex-col gap-0.5 justify-center items-center p-2 bg-white',
        {
          isEthInputOpen,
        },
      )}
    >
      <p className="text-base text-cloud-900 font-bold mb-0.75 ">Add ETH</p>
      <div className="relative w-full rounded-lg border border-cloud-900">
        <input
          type="number"
          onChange={handleChange}
          min="0"
          placeholder="0.00"
          className="block h-full w-full rounded-lg rounded-bl-lg py-1.25 pl-1.75 pr-5"
          value={enteredEthAmount !== '' ? enteredEthAmount : undefined}
          step="0.1"
        />
        <IconComp
          className="absolute right-1.75 text-cloud-400 stroke-current top-1/2 transform -translate-y-1/2 z-20"
          size={24}
          icon={EthIcon}
        />
      </div>
      <p className="text-sm text-cloud-400 text-center mt-2">Here you can add ETH to the swap.</p>
    </div>
  );
};
